module.exports = __webpack_public_path__ + "img/avatar1.1bca07b1.jpeg";